// Reserved host labels - a neutral host (not a Space). KEEP IN SYNC with
// packages/shared/src/reserved-hosts.ts. (Web doesn't import @platform1/shared
// today; small duplicated list avoids adding build wiring.)
export const RESERVED_HOST_LABELS = new Set<string>([
  'login',
  'www',
  'api',
  'admin',
  'static',
  'assets',
]);

export function isReservedHostLabel(label: string | null | undefined): boolean {
  return label != null && RESERVED_HOST_LABELS.has(label.toLowerCase());
}
